import { supabase } from '@/lib/supabase';
import type {
  TaskAssignmentsInsert,
  TaskAssignmentsRow,
} from '@/types/database.types';

export async function listAssignmentsForTask(taskId: string): Promise<TaskAssignmentsRow[]> {
  const { data, error } = await supabase
    .from('task_assignments')
    .select('*')
    .eq('task_id', taskId)
    .order('assigned_at', { ascending: true });
  if (error) throw error;
  return data ?? [];
}

export async function addAssignment(input: TaskAssignmentsInsert): Promise<TaskAssignmentsRow> {
  const { data, error } = await supabase
    .from('task_assignments')
    .insert(input)
    .select('*')
    .single();
  if (error) throw error;
  return data;
}

export async function removeAssignment(
  taskId: string,
  userId: string,
  role: string,
): Promise<void> {
  const { error } = await supabase
    .from('task_assignments')
    .delete()
    .match({ task_id: taskId, user_id: userId, role });
  if (error) throw error;
}

/**
 * Batch insert de N asignaciones a una task recién creada.
 * Las nuevas asignaciones llevan accepted_at=NULL (van al Inbox del user
 * que las recibe). La asignación creada por el propio owner se acepta
 * automáticamente porque assignedBy === userId.
 */
export async function bulkAssign(
  taskId: string,
  userIds: string[],
  assignedBy: string,
  role: 'assignee' | 'watcher' = 'assignee',
): Promise<void> {
  if (userIds.length === 0) return;
  const now = new Date().toISOString();
  const rows = userIds.map((user_id) => ({
    task_id: taskId,
    user_id,
    role,
    assigned_by: assignedBy,
    // Si el user se asigna a sí mismo, se considera aceptada en automático.
    accepted_at: user_id === assignedBy ? now : null,
  }));
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { error } = await (supabase as any)
    .from('task_assignments')
    .upsert(rows, { onConflict: 'task_id,user_id,role', ignoreDuplicates: true });
  if (error) throw error;
}
